(function ($) {
  function throttle(fn, wait) {
    var lastTime = 0;
    var timeoutId = null;
    var lastArgs, lastContext;

    return function () {
      var now = Date.now();
      lastArgs = arguments;
      lastContext = this;

      if (!lastTime) lastTime = now;

      var remaining = wait - (now - lastTime);
      if (remaining <= 0) {
        if (timeoutId) {
          clearTimeout(timeoutId);
          timeoutId = null;
        }
        lastTime = now;
        fn.apply(lastContext, lastArgs);
      } else if (!timeoutId) {
        timeoutId = setTimeout(function () {
          lastTime = Date.now();
          timeoutId = null;
          fn.apply(lastContext, lastArgs);
        }, remaining);
      }
    };
  }

  var $body        = $('body');
  var $mobileUse   = null;
  var $colorSelect = null;

  var $popup       = null;
  var $popupInner  = null;
  var $form        = null;
  var $emailInput  = null;
  var $message     = null;
  var $lastTrigger = null;

  const PUBLIC_API_KEY = 'XL9bSt';
  const ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' +
                   encodeURIComponent(PUBLIC_API_KEY);
  const REVISION = '2024-05-15';

  function inViewport() {
    var scrollTop      = window.scrollY || document.documentElement.scrollTop || 0;
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;

    var $notificationSuccess = $('#NotificationSuccess');
    var $mobileUseLocal      = $mobileUse || $('.mobile-use');
    var $colorSelectLocal    = $colorSelect || $('.colo-sel_ect');

    $notificationSuccess.toggleClass('notifyfix', scrollTop >= 100);

    var priceEl   = document.querySelector('.product-single__price-container');
    var variantEl = document.querySelector('.VariantSelects');

    if (!priceEl || !variantEl) {
      $mobileUseLocal.removeClass('fix-button');
      $colorSelectLocal.removeClass('fixswatch');
      return;
    }

    var priceRect   = priceEl.getBoundingClientRect();
    var variantRect = variantEl.getBoundingClientRect();

    var passedPriceTop      = priceRect.top < 0;
    var beforeVariantBottom = variantRect.bottom > (viewportHeight - 80);

    var shouldStick = passedPriceTop && beforeVariantBottom;

    if (shouldStick) {
      $colorSelectLocal.addClass('fixswatch');
      $mobileUseLocal.addClass('fix-button');
    } else {
      $colorSelectLocal.removeClass('fixswatch');
      $mobileUseLocal.removeClass('fix-button');
    }

    var qtyEl = document.querySelector('.product-form__item--quantity');
    if (qtyEl) {
      var qtyRect = qtyEl.getBoundingClientRect();
      if (qtyRect.top < 0) {
        $colorSelectLocal.removeClass('fixswatch');
      }
    }
  }

  // checkVariantHeight removed – classes are now managed via Liquid

  function closeBisPopup() {
    if (!$popup || !$popup.length) {
      $popup      = $('#bis-popup');
      $popupInner = $popup.find('.bis-popup__inner');
    }

    $popup.addClass('hidden');
    $body.css('overflow', '');
    if ($lastTrigger && $lastTrigger.length) {
      $lastTrigger.focus();
    }
  }

  $(document).ready(function () {
    $mobileUse   = $('.mobile-use');
    $colorSelect = $('.colo-sel_ect');

    $popup      = $('#bis-popup');
    $popupInner = $popup.find('.bis-popup__inner');
    $form       = $('#bis-form');
    $emailInput = $('#bis-email');
    $message    = $('#bis-message');

    // checkVariantHeight();  // removed – handled in Liquid now

    var throttledScroll = throttle(inViewport, 50);
    throttledScroll();
    window.addEventListener('scroll', throttledScroll, { passive: true });

    (function setupSwalObserver() {
      var targetNode = document.body;
      var swalObserver;

      function enhanceSwal() {
        var $overlayShown = $('.swal-overlay--show-modal');
        if (!$overlayShown.length) return;
        if (swalObserver) {
          swalObserver.disconnect();
        }

        var $overlay    = $('.swal-overlay');
        var $modal      = $('.swal-modal');
        var $confirmBtn = $('.swal-button--confirm');
        var $backFocus  = $('.product-form__cart-submit');

        $overlay.removeAttr('tabindex');

        if ($modal.length) {
          $modal
            .attr({
              tabindex: '-1',
              'aria-label': 'Quantity Alert'
            })
            .focus();
        }

        $confirmBtn.on('click', function (e) {
          e.stopPropagation();
          if ($backFocus.length) {
            $backFocus.focus();
          }
        });
      }

      if (!targetNode || typeof MutationObserver === 'undefined') {
        var checkSwal = setInterval(function () {
          if ($('.swal-overlay--show-modal').length) {
            clearInterval(checkSwal);
            enhanceSwal();
          }
        }, 1000);
        return;
      }

      swalObserver = new MutationObserver(function (mutationsList) {
        for (var i = 0; i < mutationsList.length; i++) {
          var mutation = mutationsList[i];
          if (mutation.addedNodes && mutation.addedNodes.length) {
            enhanceSwal();
            break;
          }
        }
      });

      swalObserver.observe(targetNode, {
        childList: true,
        subtree: true
      });

      enhanceSwal();
    })();

    if ($popup.length && $form.length) {
      $(document).on('click', '.bis-button', function () {
        $lastTrigger = $(this);

        $message.text('').addClass('visually-hidden');
        $emailInput.val('');

        $popup.removeClass('hidden');
        $body.css('overflow', 'hidden');

        $popupInner.attr('tabindex', '-1').focus();
      });

      $popup.on('click', '.bis-close', function () {
        closeBisPopup();
      });

      $(document).on('keydown', function (e) {
        if (e.key === 'Escape' && !$popup.hasClass('hidden')) {
          closeBisPopup();
        }
      });

      $form.on('submit', function (e) {
        e.preventDefault();

        var email = $emailInput.val().trim();
        if (!email) {
          $message
            .text('Please enter a valid email address.')
            .removeClass('visually-hidden');
          return;
        }

        var $visibleBisButton = $('.bis-button:visible');
        var variantId = $visibleBisButton.data('variant-id');

        if (!variantId) {
          $message
            .text('Could not detect product variant. Please try again.')
            .removeClass('visually-hidden');
          return;
        }

        var compositeVariantId = '$shopify:::$default:::' + variantId;

        var payload = {
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email
                  }
                }
              }
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: compositeVariantId
                }
              }
            }
          }
        };

        $message.text('').addClass('visually-hidden');

        var $submitBtn = $form.find('button[type="submit"]');
        $submitBtn.prop('disabled', true);

        fetch(ENDPOINT, {
          method: 'POST',
          headers: {
            accept: 'application/json',
            'content-type': 'application/json',
            revision: REVISION
          },
          body: JSON.stringify(payload)
        })
          .then(function (res) {
            if (!res.ok) {
              return res.text().then(function (text) {
                var detail;
                try {
                  var data = text ? JSON.parse(text) : null;
                  if (
                    data &&
                    data.errors &&
                    data.errors[0] &&
                    data.errors[0].detail
                  ) {
                    detail = data.errors[0].detail;
                  }
                } catch (e) {}
                throw new Error(detail || 'Network error ' + res.status);
              });
            }
            return null;
          })
          .then(function () {
            $message
              .text('You will be notified when this item is back in stock.')
              .removeClass('visually-hidden');
            $submitBtn.prop('disabled', false);
          })
          .catch(function (err) {
            console.error('[BIS] submission error:', err);
            $message
              .text('There was a problem. Please try again.')
              .removeClass('visually-hidden');
            $submitBtn.prop('disabled', false);
          });
      });
    }
  });
})(jQuery);
